import GlobalDispatcher from 'Engine/events/GlobalDispatcher';
import FlashLib from 'flashlib_onlyplay';
import animationTypes from '../animations/animationTypes';
import animationCreator from 'Engine/animations/animationCreator';
import eSymbolIndex from './eSymbolIndex';

export default class SymbolAnimation extends FlashLib.MovieClip {
  constructor(data, displayItemData) {
    super(data, displayItemData);
    this.animationNames = {
      [eSymbolIndex.ESI_COOKIE]: '7_cookie',
      [eSymbolIndex.ESI_WREATH]: '7_tree',
      [eSymbolIndex.ESI_CANDY]: '7_candy',
      [eSymbolIndex.ESI_CANDLE]: '7_honey',
      [eSymbolIndex.ESI_SOCK]: '7_sock',
      [eSymbolIndex.ESI_ICE]: '7_ice',
      [eSymbolIndex.ESI_BOMB]: '7_bomb',
      [eSymbolIndex.ESI_SNOW]: '7_snow',
      [eSymbolIndex.ESI_SCATTER]: 'free_spins',
    };

    this.stopAnimationNames = {
      [eSymbolIndex.ESI_SCATTER]: 'free_spins_stop',
    };

    this.onComplete = () => {};

    this.animationListener = {
      complete: () => {
        this._complete(this)
      }
    };

    this.animation = null;
    this.init()
    this.addListeners();
  }

  init() {
    this.animation = animationCreator.createAnimation(animationTypes.SYMBOLS);
    this.animation.visible = false;
    this.animation.state.addListener(this.animationListener);
    this.addChild(this.animation);
  }

  addListeners() {
    GlobalDispatcher.add('stateStart:jackpotGameInState', ()=> this.isActive = this.animation.visible, this);
    GlobalDispatcher.add('stateStart:jackpotGameOutState', () => this.animation.visible = this.isActive, this);
  }

  start(loop) {
    this._playSpineAnimation(loop);
  }

  _playSpineAnimation(loop) {
    this.animation.visible = true;
    this.animation.state.setAnimation(0, this.animationNames[this.id], loop);
  }
  startStopAnimation() {
    this.animation.visible = true;
    this.animation.skeleton.setToSetupPose();
    this.animation.state.setAnimation(0, this.stopAnimationNames[this.id], false);
  }

  _complete() {
    // this.animation.visible = false;
    this.onComplete();
    // this.emit('animationComplete', this);
  }

  stop() {
    if (this.animation) {
      this.animation.visible = false
    }
  }
}
